export default class FormDataSourceGroupLinkType
{
	static PASSIVE = "Passive";
	static DELAYED = "Delayed";
	static ACTIVE = "Active";
	
	static isLinkType(value)
	{
		if(value == FormDataSourceGroupLinkType.PASSIVE || value == FormDataSourceGroupLinkType.DELAYED || value == FormDataSourceGroupLinkType.ACTIVE || value == "")
			return true;
		return false;
	}
}


// WEBPACK FOOTER //
// ./src/datasource/FormDataSourceGroupLinkType.js